<template>
<div>
    <!--hero section start-->
    <section class="hero-section pt-100 background-img" style="background: url('./static/img/hero-bg.jpg')no-repeat fixed center center / cover;">
        <div class="container">
            <div class="row align-items-center justify-content-between">
                <div class="col-md-6 col-lg-6">
                    <div class="hero-content-left text-white mt-5 mb-5">
                        <h1 class="text-white"><span>¡Bienvenido!</span></h1>
                        <p class="lead">En este espacio podrás realizar tus pagos en línea para los servicios y actividades que el Servicio de Parques de Lima Ofrece.</p>
                        <a href="https://www.serpar.gob.pe/protocolo-bioseguridad/" target="_new" class="btn app-store-btn mb-5 d-none">Ver protocolos de bioseguridad</a>
                    </div>
                </div>
                <div class="col-md-6 col-lg-5">
                    <div class="hero-animation-img">
                        <img :src="'./static/img/about-img.png'" alt="img" class="img-fluid d-none">
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--hero section end-->

    <!--Services start-->
    <section class="my-4">
        <div class="text-center">
            <div class="text-center my-5">
                <h2 class="section-title">Tienda digital de Serpar</h2>
                <span>Adquiere tus productos o servicios aquí</span>
            </div>
        </div>
        <div class="container">
            <div class="row mb-4 justify-content-center">
                <div v-for="(item, index) in listServices" :key="index" class="col-10 col-md-6 col-lg-3 mb-4">
                    <div class="card-event-content">
                        <router-link :to="item.slug" class="card-event is-online">
                            <span class="card-event__star d-none"><i class="fa fa-star"></i></span>
                            <div class="card-event__img mb-1">
                                <img class="img-fluid" :src="item.img" :alt="item.title">
                            </div>
                            <div class="card-event__body">
                                <h2 class="card-event__title mb-2">{{item.title}}</h2>
                                <div :to="item.slug" class="card-event__action film">{{item.button_text}}</div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

    </section>
    <br><br>
    <!--Services end-->

    <!--court rental-->
    <section id="features" class="feature-section ptb-100  gray-light-bg d-none">
        <div class="container">
            <div class="row align-items-center justify-content-between">
                <div class="col-md-4">
                    <div class="download-img">
                        <img :src="'./static/img/alquiler-cancha.jpg'" alt="download" class="img-fluid">
                    </div>
                </div>
                <div class="col-md-7">
                    <div class="feature-contents section-heading">
                        <h2>Alquiler de canchas deportivas<br>
                            <span>en nuestros parques y clubes zonales</span></h2>
                        <p>Lozas de futbol, fulbito, voley, frontón de gras natural y sintético disponibles de 6.a.m hasta las 11.p.m</p>
                    </div>
                    <button class="btn outline-btn mb-3" @click="next">Empezar</button>
                </div>
            </div>
        </div>
    </section>
    <!--court rental end-->
    <!--epresencial section start-->
    <section class="epresencial-section ptb-100  d-none">
        <div class="container">
            <div class="row">
                <div class="col-sm-5">
                    <i class="el-icon-location-information display-4 mb-4"></i>
                    <h2>Escuelas presenciales<br><span>de verano</span></h2>
                    <router-link class="btn solid-btn mt-5" to="/escuelas/presenciales">Inscríbete ahora</router-link>
                </div>
                <div class="col-sm-6">
                    <div class="about-content-left section-heading">
                        <div class="single-feature mb-4 mt-5">
                            <div class="icon-box-wrap d-flex align-items-center mb-2">
                                <div class="mr-3 icon-box">
                                    <i class="el-icon-finished" style="font-size:2.5rem;"></i>
                                </div>
                                <p class="mb-0">Elige entre más de 10 disciplinas deportivas según el parque o club zonal más cercano para ti.</p>
                            </div>
                        </div>
                        <div class="single-feature mb-4">
                            <div class="icon-box-wrap mb-2">
                                <div class="mr-3 icon-box">
                                    <i class="el-icon-finished" style="font-size:2.5rem;"></i>
                                </div>
                                <p class="mb-0">Contamos con todos los protocolos de bioseguridad en nuestras sedes.</p>
                            </div>
                            <p></p>
                        </div>
                        <div class="single-feature mb-4">
                            <div class="icon-box-wrap mb-2">
                                <div class="mr-3 icon-box">
                                    <i class="el-icon-finished" style="font-size:2.5rem;"></i>
                                </div>
                                <p class="mb-0">Aforos reducidos para garantizar el aprendizaje y seguridad de nuestros alumnos.</p>
                            </div>
                            <p></p>
                        </div>
                        <div class="single-feature mb-4">
                            <div class="icon-box-wrap mb-2">
                                <div class="mr-3 icon-box">
                                    <i class="el-icon-finished" style="font-size:2.5rem;"></i>
                                </div>
                                <p class="mb-0">Variedad de horarios en las distintas sedes según la disciplina.</p>
                            </div>
                            <p></p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>
    <!--epresencial section end-->
    <!--evirtual section start-->
    <section class="promo-section ptb-100 gray-light-bg d-none">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-7 col-md-8">
                    <div class="section-heading text-center mb-5">
                        <h2>Escuelas virtuales</h2>
                        <router-link :to="'/escuelas/virtuales'" class="badge badge-warning badge-pill">Ver todas las escuelas</router-link>
                        <p class="lead">Elige una categoría y conoce sus cursos disponibles.</p>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center">
                <router-link v-for="item in listVirtual" :key="item.id" class="col-md-4 col-lg-4" :to="'escuelas/virtuales?category='+item.slug">
                    <div class="single-promo single-promo-hover single-promo-1 rounded text-center white-bg p-5 h-100">
                        <div class="circle-icon mb-5 d-none">
                            <span class="ti-lock text-white"></span>
                        </div>
                        <img :src="item.img" alt="pricing img" class="img-fluid">
                        <h5 v-text="item.name"></h5>
                    </div>
                </router-link>
            </div>
        </div>
    </section>
    <!--evirtual section end-->
    <!--Subastas start-->
    <section class="epresencial-section ptb-100 d-none" style="background-image: url('https://www.serpar.gob.pe/wp-content/uploads/2019/12/Subasta-serpar-2.jpg');
background-size: cover;
background-repeat: no-repeat;">
        <div class="container">
            <div class="row">
                <div class="col-sm-6">
                    <div class="about-content-left section-heading">

                    </div>
                </div>
                <div class="col-sm-5">
                    <i class="el-icon-location-information display-4 mb-4"></i>
                    <h2 class="text-white">Compra de bases<br><span class="text-white">para subastas</span></h2>
                    <p class="text-white">Estimado usuario, ahora ya puedes comprar tus bases en linea para que participes en todas nuestras bases</p>
                    <router-link class="btn solid-btn mt-5" to="/subastas">Empezar ahora</router-link>
                </div>
            </div>
        </div>

    </section>
    <!--Subastas end-->

</div>
</template>

<script>
export default {
    name: 'Home',
    data() {
        return {
            listServices: [],
            listVirtual: [],
        }
    },
    methods: {
        getServices(){
            axios.get(`${process.env.API1}/api/services`).then(response => {
                this.listServices = response.data;
            });
        },
        getListVirtual() {
            axios.post(`${process.env.API1}/virtual/category`).then(response => {
                this.listVirtual = response.data;
            });
        },
        next() {
            this.$router.push({path: `/canchas`});
        }
    },
    created() {
        this.$store.dispatch("updateSubRouter", false);
        this.getServices();
        this.getListVirtual();
    }
}
</script>
<style>
.card-event {
 font-size:14px;
 display:block;
 border-radius:0.5rem;
 background:#fff;
 overflow:hidden;
 position:relative;
 color:#1a171b;
 box-shadow:2px 3px 6px rgba(0,0,0,0.15);
 transition:0.5s all
}
.card-event:before {
 content:"";
 position:absolute;
 left:0;
 top:0;
 right:0;
 bottom:0;
 background-image:linear-gradient(rgba(255,255,255,0) 10%, rgba(255,255,255,0.9) 50%, #fff 75%);
 z-index:5;
 opacity:0;
 transition:0.6s all
}
.card-event:hover,
.card-event.active {
 text-decoration:none;
 color:inherit
}
.card-event:hover .card-event__action,
.card-event.active .card-event__action {
 box-shadow:1px 2px 4px rgba(0,0,0,0.15)
}
.card-event:hover {
 box-shadow:2px 6px 18px rgba(0,0,0,0.2)
}

.card-event.is-online .card-event__calendar {
 background-color:rgba(0,0,0,0.25)
}
.card-event__soldout {
 color:#fff;
 background-color:rgba(0,0,0,0.6);
 text-transform:uppercase;
 font-weight:600;
 font-size:1.25rem;
 display:flex;
 justify-content:center;
 align-items:center;
 position:absolute;
 left:0;
 top:0;
 right:0;
 bottom:0;
 z-index:8
}
.card-event__star {
 color:#fff;
 width:60px;
 height:60px;
 border-top-left-radius:6px;
 overflow:hidden;
 position:absolute;
 left:0px;
 top:0px;
 z-index:9
}
.card-event__star i {
 position:relative;
 z-index:2;
 left:7px;
 top:4px
}
.card-event__star:before {
 content:"";
 position:absolute;
 left:-5px;
 top:-5px;
 border-left:60px solid #42a692;
 border-bottom:60px solid transparent
}


.card-event__img img {
 width:100%;
 -o-object-fit:cover;
 object-fit:cover;
 background:#999;
 -webkit-animation:fadeBgEvent 1s infinite;
 animation:fadeBgEvent 1s infinite;
 transition:0.4s all ease-in-out
}
.card-event__body {
 padding:1rem 0.9rem;
 position:relative;
 z-index:9
}
.card-event__address {
 margin-bottom:0.5rem;
 opacity:0.75;
 display:block;
 display:-webkit-box;
 -webkit-line-clamp:1;
 -webkit-box-orient:vertical;
 overflow:hidden;
 text-overflow:ellipsis;
 height:18px
}

.card-event__title {
 font-size:16px;
 font-weight:600;
 transition:0.4s all;
 line-height:1.4;
 display:block;
 display:-webkit-box;
 -webkit-line-clamp:2;
 -webkit-box-orient:vertical;
 overflow:hidden;
 text-overflow:ellipsis;
 height:42px;
 color: #1A4A84 !important; text-align: center;
}
.card-event__title strong {
 font-weight:600
}
.card-event__footer {
 display:flex;
 align-items:flex-end;
 justify-content:space-between
}
.card-event__action {
 height:32px;
 text-align:center;
 padding:0.3rem 1rem;
 font-weight:400;
 transition:all 0.5s;
 border-radius:0.2rem;
 color:#fff;
 background:#42a692;
 border-radius:50px;
 white-space:nowrap
}
.card-event__action.disabled {
 text-transform:uppercase;
 background:#adb5bd
}
.card-event__action.muted {
 background:#6c757d
}
.card-event__action.donation {
 background:#F04D4D
}
.card-event__links {
 color:#000;
 text-decoration:none
}
.card-event__links:hover {
 color:#000;
 text-decoration:none
}
.card-event-remove {
 position:absolute;
 left:0;
 top:0;
 right:0;
 bottom:0;
 z-index:99;
 border-radius:0.5rem;
 padding:1rem;
 background:rgba(0,0,0,0.9);
 color:#fff;
 display:flex;
 align-items:center;
 justify-content:center;
 text-align:center
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue